import {
  ProductsActionsUnion,
  ProductsActionTypes,
} from './products.actions';
import { productsInitialState } from './products.state';

export function productsReducer(state = productsInitialState, action: ProductsActionsUnion) {
  switch (action.type) {
    case ProductsActionTypes.LOAD_PRODUCTS:
      return { ...state, loading: true };
    case ProductsActionTypes.RESET_PRODUCTS:
      return {
        ...state,
        payload: {
          ...state.payload,
          correction: productsInitialState.payload.correction,
          products: productsInitialState.payload.products,
          metaData: productsInitialState.payload.metaData
        }
      };
    case ProductsActionTypes.LOAD_PRODUCTS_SUCCESS:
      const { response, queryOptions: { limit, offset, filter } } = action.payload;
      return {
        ...state,
        payload: {
          correction: response.correction,
          products: {
            items: response.products.items,
            totalCount: response.products.totalCount
          },
          recommendedProducts: response.recommendedProducts || null,
          metaData: response.metaData
        },
        loading: false,
        error: null,
        currentFilter: filter,
        currentOffset: offset,
        currentLimit: limit
      };
    case ProductsActionTypes.LOAD_PRODUCTS_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
        payload: {
          correction: '',
          products: {
            items: [],
            totalCount: 0
          },
          recommendedProducts: null,
          metaData: null
        },
        currentFilter: {},
        currentOffset: 0,
        currentLimit: 0
      };
    default:
      return state;
  }
}
